import { combineReducers } from 'redux'
import parse from '../adapters/parsers/pricesParser'
import { handleResponse } from './api/apiUtils'
import * as urls from './api/urls'
import { SET_CURRENT_PROPERTY } from './properties'

/* Constants */
export const PRICES_REQUEST = 'PRICES_REQUEST'
export const PRICES_SUCCESS = 'PRICES_SUCCESS'
export const PRICES_CLEAR = 'PRICES_CLEAR'
export const PRICES_FAILURE = 'PRICES_FAILURE'

/* Reducers */

/** @reducer **/
const entities = (state = {}, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return {}
        case PRICES_SUCCESS:
            return action.payload.entities
        case PRICES_CLEAR:
            return {}
        default:
            return state
    }
}

const currency = (state = {}, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return {}
        case PRICES_SUCCESS:
            return action.payload.currency
        case PRICES_CLEAR:
            return []
        default:
            return state
    }
}

const result = (state = {}, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return {}
        case PRICES_SUCCESS:
            return action.payload.result
        case PRICES_CLEAR:
            return []
        default:
            return state
    }
}

const error = (state = null, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return null
        case PRICES_FAILURE:
            return action.payload
        case PRICES_SUCCESS:
            return null
        default:
            return state
    }
}

const isFetching = (state = false, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return false
        case PRICES_REQUEST:
            return true
        case PRICES_SUCCESS:
        case PRICES_FAILURE:
        case PRICES_CLEAR:
            return false
        default:
            return state
    }
}

export const pricesReducer = combineReducers({ entities, result, currency, isFetching, error })

/* Thunks */

/**
 * Fetches array of total prices by categories
 *
 * @param {Object} params - List of path params
 * @param {number} params.startTime - Selected startTime in UTC+0 UNIX timestamp
 * @param {number} params.endTime - Selected endTime in UTC+0 UNIX timestamp
 * @param {number} organizationId - Current organization Id
 */
export const getPrices = params => (dispatch, getState) => {
    dispatch(pricesRequest())

    const { secretKey, properties } = getState()
    const { currentProperty } = properties

    const opts = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    }

    fetch(urls.pricesUrl(secretKey, {
        propertyId: currentProperty ,
        ...params
    }), opts)
        .then(handleResponse)
        .then(json => parse(json))
        .then(json => dispatch(pricesSuccess(json)))
        .catch(err => console.error(err))
}

/**
 * Clears available categories from store
 */
export const clearPrices = () => dispatch => {
    dispatch(pricesClear())
}

/* Action Creators */

/** @action **/
export const pricesRequest = () => ({
    type: PRICES_REQUEST
})

/** @action **/
export const pricesSuccess = prices => ({
    type: PRICES_SUCCESS,
    payload: { entities: prices.entities, currency: prices.currency, result: prices.result }
})

/** @action **/
export const pricesClear = () => ({
    type: PRICES_CLEAR
})

/** @action **/
export const pricesFailure = error => ({
    type: PRICES_FAILURE,
    payload: {
        status: error.response.status,
        statusText: error.response.statusText
    }
})



// WEBPACK FOOTER //
// ./modules/prices.js